import { useLocation as useGeo } from "@/contexts/LocationContext";
import { Button } from "@/components/ui/button";
import { MapPin, LocateFixed, X } from "lucide-react";

export default function LocationBar() {
  const { loc, loading, request, clear } = useGeo();
  return (
    <div className="flex items-center gap-2">
      {loc ? (
        <>
          <div className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-teal-50 border border-teal-200 text-teal-800 text-sm" data-testid="location-active">
            <MapPin className="w-4 h-4" /> Sorting by nearest to you
          </div>
          <Button variant="ghost" size="sm" onClick={clear} data-testid="location-clear">
            <X className="w-4 h-4" />
          </Button>
        </>
      ) : (
        <Button variant="outline" size="sm" onClick={request} disabled={loading} data-testid="location-request">
          <LocateFixed className="w-4 h-4 mr-2" />
          {loading ? "Detecting…" : "Use my location"}
        </Button>
      )}
    </div>
  );
}
